import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Route,
} from "react-router";
import Home from "./pages/Home";
import NavBarLayout from "./layouts/NavBarLayout";
import SignupPage from "./pages/Signup/SignupPage";
import LoginPage from "./pages/Login/LoginPage";
import StudentSignupPage from "./pages/Signup/StudentSignupPage";
import LecturerSignupPage from "./pages/Signup/LecturerSignupPage";
import Test from "./pages/Test";
import ProctectedRoute from "./components/ProtectedRoute";
import RootLayout from "./layouts/RootLayout";
import AdminLayout from "./layouts/AdminLayout";
import CourseManagementPage from "./pages/Admin/Courses/CourseManagementPage";
import RequestResetPasswordPage from "./pages/ForgotPassword/RequestResetPasswordPage";
import ResetPasswordPage from "./pages/ForgotPassword/ResetPasswordPage";
import AnalyticsPage from "./pages/Admin/Analytics/AnalyticsPage";
import { Toaster } from 'sonner';
import RoleSelectionPage from "./pages/Signup/RoleSelectionPage";
import ProfilePage from "./pages/Profile/ProfilePage";
import TopicManagementPage from "./pages/Admin/Topics/TopicManagementPage";
import { TopicProvider } from "./contexts/TopicContext";
import UniversityManagementPage from "./pages/Admin/University/UniversityManagementPage";
import { UniversityProvider } from "./contexts/UniversityContext";
import FacultyManagementPage from "./pages/Admin/Faculty/FacultyManagementPage";
import DepartmentManagementPage from "./pages/Admin/Department/DepartmentManagementPage";
import { DepartmentProvider } from "./contexts/DepartmentContext";
import { FacultyProvider } from "./contexts/FacultyContext";
import QuizManagementPage from "./pages/Admin/Quiz/QuizManagementPage";
import DiscoverPage from './pages/Discover/DiscoverPage';
import QuizDetailPage from './pages/Quiz/QuizDetailPage';
import StartQuizPage from './pages/Quiz/StartQuizPage';
import CourseTopicPage from "./pages/Discover/CourseTopicPage";
import QuizResultsPage from "./pages/Quiz/QuizResultsPage";
import AdminQuizResponsePage from "./pages/Admin/QuizResponse/AdminQuizResponsePage";
import LecturerLayout from "./layouts/LecturerLayout";
import LecturerQuizzesPage from "./pages/Lecturer/LecturerQuizzesPage";
import { QuizProvider } from "./contexts/QuizContext";
import QuizResponsePage from "./pages/Lecturer/QuizResponsePage";
import AdminOrLecturerLayout from "./layouts/AdminOrLecturerLayout";
import SubscriptionPage from "./pages/Subscription/SubscriptionPage";
import QuestionBankPage from "./pages/Admin/QuestionBank/QuestionBankPage";
import QuizQuestionManagementPage from "./pages/Admin/Quiz/QuizQuestionManagementPage";
import QuestionBankManagementPage from "./pages/Admin/QuestionBank/QuestionBankManagementPage";

const routes = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<RootLayout />}>
      <Route index element={<Home />} />
      <Route path="/test" element={<Test />} />

      {/* pages with top navbar */}
      <Route element={<NavBarLayout />}>
        <Route path="login" element={<LoginPage />} />
        <Route path="request-reset-password" element={<RequestResetPasswordPage />} />
        <Route path="reset-password/:userId/:token" element={<ResetPasswordPage />} />
        <Route path="signup" element={<SignupPage />} />
        <Route path="subscription" element={<SubscriptionPage />} />

        <Route path="discover" element={<DiscoverPage />} />
        <Route path="topics/:course_id" element={<CourseTopicPage /> }/>

        <Route path="topics/:topic_id/quizzes" element={<QuizDetailPage />} />

        {/* protected routes */}
        <Route element={<ProctectedRoute />}>
          {/* profile completion routes */}
          <Route path="complete-profile">
            <Route index element={<RoleSelectionPage />} />
            <Route path="student" element={<StudentSignupPage />} />
            <Route path="lecturer" element={<LecturerSignupPage />} />
            <Route path="role-selection" element={<RoleSelectionPage />} />
          </Route>

          {/* page where users take quiz */}
          <Route path="quizzes/:quiz_id/view" element={<StartQuizPage />} />
          <Route path="quizzes/:session_id/results" element={<QuizResultsPage />} />

          {/* routes that require completed profile */}
          <Route path="profile" element={<ProfilePage />} />
          <Route path="admin" element={<AdminLayout />} >
            <Route index element={<AnalyticsPage />} />
            <Route path="courses" element={<CourseManagementPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="university" element={
              <UniversityProvider>
                <UniversityManagementPage />
              </UniversityProvider>
            } />
            <Route path="topics" element={
              <TopicProvider>
                <TopicManagementPage />
              </TopicProvider>
            } />
            <Route path="department" element={
              <DepartmentProvider>
                <DepartmentManagementPage />
              </DepartmentProvider>
            } />
            <Route path="faculty" element={
              <FacultyProvider>
                <FacultyManagementPage />
              </FacultyProvider>
            } />
            <Route path="quizzes" element={
              <QuizProvider>
                <QuizManagementPage/>
              </QuizProvider>
            } />
            <Route
              path="quizzes/response"
              element={<AdminQuizResponsePage />}
            />
            <Route path="question-bank" element={<QuestionBankPage />} />
            <Route path="question-bank/:topic_id" element={<QuestionBankManagementPage/>} />
          </Route>


          <Route path="manage/quizzes" element={<AdminOrLecturerLayout />}>
            <Route path=":quiz_id" element={<QuizQuestionManagementPage />} />
            <Route path=":quiz_id/responses" element={<QuizResponsePage />} />
          </Route>

          <Route path="lecturer" element={<LecturerLayout/>}>
            <Route path="quizzes" element={
              <QuizProvider isLecturer={true}>
                <LecturerQuizzesPage/>
              </QuizProvider>
            }/>
          </Route>
        </Route>
      </Route>

      {/* pages without top navbar */}
    </Route >
  )
)

function App() {
  return (
    <>
      <RouterProvider router={routes} />
      <Toaster position="top-center" richColors={true} />
    </>
  )
}

export default App
